import React from "react";
import { PureAppComponent } from "../../../Components/AppComponent";
import {
  Form,
  Button,
  InputGroup,
  FormControl,
  ButtonGroup,
  ToggleButton,
  ToggleButtonGroup,
} from "react-bootstrap";
import { connect } from "react-redux";
import _ from "lodash";

import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import AppModal from "../../../Components/Models/app-modal";
import { getFullName } from "../../../Modules/utils/fullname";
import api from "../../../Services/Api/api";
import AppTable from "../../Components/AppTable";
import { isMobile } from "react-device-detect";
import AccountDetails from "../AccountsScreen/AccountDetails";

const SCREEN_NAME = "AGENT_DETAILS_SCREEN";

class ActiveAccountsOfAgentInner extends PureAppComponent {
  constructor(props) {
    super(props);

    const refDate = new Date().setMonth(new Date().getMonth());
    this.state = {
      loading: false,
      error: null,
      visibleModal: null,
      modalData: null,
      period: "monthly",
      range0: null,
      range1: null,
      month: new Date(refDate).getMonth(),
      year: new Date(refDate).getFullYear(),
      accountType: "all",
    };

    let columns = [
      {
        value: "sl",
        label: "SL No",
        render: ({ index }) => index + 1,
      },
      {
        value: "name",
        label: "Name",
        render: ({ item }) => getFullName(item.customer),
      },
      {
        value: "shortId",
        label: "Account ID",
        render: ({ item }) => (
          <div
            className="hoveredlink"
            onClick={(e) => {
              e.stopPropagation();
              this.setAsyncState({
                visibleModal: "accountDetails",
                modalData: { account: item },
              });
            }}
          >
            {item?.shortId}
          </div>
        ),
      },
      {
        value: "accountType",
        label: "Account Type",
        render: ({ item }) => _.startCase(item.accountType),
      },
      {
        value: "createdAt",
        label: "Created At",
        render: ({ item }) => new Date(item.createdAt).toLocaleDateString(),
      },
      {
        value: "closingDate",
        label: "Closing Date",
        render: ({ item }) =>
          item.closingDate
            ? new Date(item.closingDate).toLocaleDateString()
            : null,
      },
      {
        value: "status",
        label: "Status",
        render: ({ item }) => (item.closed ? "Closed" : "Active"),
      },
    ].filter((x) => (isMobile ? !x.hideInMobile : true));

    if (this.props.filteredColumns) {
      let newColumns = [];

      for (let i = 0; i < this.props.filteredColumns.length; i++) {
        const colValue = this.props.filteredColumns[i];

        const col = columns.find((x) => x.value === colValue);
        if (col) {
          newColumns.push(col);
        }
      }

      this.columns = newColumns;
    } else {
      this.columns = columns;
    }

    this.months = "January, February, March, April, May, June, July, August, September, October, November, December"
      .split(",")
      .map((x) => x.trim());
  }

  componentDidMount() {
    this.onMount();
    this.load();
  }

  async load() {
    try {
      if (!this.props.agent?._id) throw new Error("Agent not selected");

      if (this.state.loading) return;
      let range0, range1;
      if (this.state.period === "monthly") {
        let refDate = new Date(this.state.year, this.state.month);

        range0 = refDate.getTime();
        range1 = new Date(refDate).setMonth(refDate.getMonth() + 1);
      } else {
        range0 = new Date(this.state.range0).setHours(0, 0, 0, 0);
        range1 = new Date(this.state.range1).setHours(0, 0, 0, 0);
      }

      this.setAsyncState({ loading: true, error: null });

      const { accounts } = await api.get("v1/account", {
        queryStr: JSON.stringify({
          where: {
            collector: this.props.agent?._id,
            createdAt: {
              $lt: range1,
            },
            $or: [
              { closed: true, closingDate: { $gt: range0 } },
              { closed: false },
            ],
          },
          limit: 0,
          populate: "customer",
        }),
      });

      this.setAsyncState({ loading: false, accounts });
    } catch (e) {
      this.setAsyncState({ loading: false, error: e.message });
    }
  }

  renderInner() {
    const {
      state: {
        loading,
        error,
        accounts,
        period,
        month,
        year,
        range0,
        range1,
        visibleModal,
        modalData,
        accountType,
      },
    } = this;

    return (
      <div className="collector-accounts">
        {/* {error ? <div className="errormsg">{error}</div> : null} */}

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            this.load();
          }}
        >
          <div style={{ display: "flex" }}>
            <ButtonGroup className="mb-3">
              {[
                { name: "Monthly", value: "monthly" },
                { name: "Custom", value: "custom" },
              ].map((radio, idx) => (
                <ToggleButton
                  key={idx}
                  id={`agent-reciept-range-radio-${idx}`}
                  type="radio"
                  variant={"outline-success"}
                  name="radio"
                  value={radio.value}
                  checked={period === radio.value}
                  onChange={(e) =>
                    this.setAsyncState({ period: e.currentTarget.value })
                  }
                >
                  {radio.name}
                </ToggleButton>
              ))}
            </ButtonGroup>
            <div style={{ width: "100px" }}></div>

            <ToggleButtonGroup
              value={[accountType]}
              onChange={(value) => this.setState({ accountType: value })}
              type="radio"
              name="accountType"
              className="mb-3"
            >
              {[
                { name: "All", value: "all" },
                { name: "Loan", value: "loan" },
                { name: "Deposit", value: "deposit" },
              ].map((radio, idx) => (
                <ToggleButton
                  key={idx + "accountType"}
                  id={`account-accountType-filter-radio-${idx}`}
                  variant={"outline-success"}
                  name={radio.name}
                  value={radio.value}
                >
                  {radio.name}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </div>

          {loading ? <span className="m-3">Loading...</span> : null}

          {period === "monthly" ? (
            <InputGroup className="mb-3">
              <FormControl
                value={month || ""}
                onChange={(e) => this.setState({ month: e.target.value })}
                as="select"
                required
              >
                <option value="">Select Month</option>
                {this.months.map((x, i) => (
                  <option key={i} value={i}>
                    {x}
                  </option>
                ))}
              </FormControl>
              <FormControl
                type="number"
                value={year || ""}
                onChange={(e) => this.setState({ year: e.target.value })}
                placeholder="Year"
                required
              />

              <Button disabled={loading} type="submit">
                Generate
              </Button>
            </InputGroup>
          ) : (
            <InputGroup className="mb-3">
              <FormControl
                type="date"
                value={range0 || ""}
                onChange={(e) => this.setState({ range0: e.target.value })}
                placeholder="From Date"
                required
              />

              <FormControl
                type="date"
                value={range1 || ""}
                onChange={(e) => this.setState({ range1: e.target.value })}
                placeholder="To Date"
                required
              />

              <Button disabled={loading} type="submit">
                Generate
              </Button>
            </InputGroup>
          )}
        </Form>

        <div>
          <AppTable
            {...{
              items:
                accountType === "all"
                  ? accounts || []
                  : (accounts || []).filter(
                      (x) => accountType === x.accountType
                    ),
              loading,
              error,
              table: {
                columns: this.columns,
              },
            }}
          />
        </div>

        <AccountDetails
          {...{
            key: `accountDetails-${
              visibleModal === "accountDetails"
                ? modalData?.account?.shortId || "new"
                : "disabled"
            }`,

            renderModal: true,
            visible: visibleModal === "accountDetails",
            shortId: modalData?.account?.shortId,
            handleClose: () => this.setAsyncState({ visibleModal: null }),

            ...(modalData || {}),
          }}
        />
      </div>
    );
  }

  renderModal() {
    return (
      <AppModal
        {...{
          visible: this.props.visible,
          handleClose: this.props.handleClose,
          title: `Collector's Accounts`,
          showFooter: false,
          modalProps: {
            fullscreen: "lg-down",
            size: "lg",
            scrollable: true,
          },
        }}
      >
        {this.renderInner()}
      </AppModal>
    );
  }

  render() {
    const {
      props: { renderModal = false, agent },
    } = this;

    if (!agent?._id) return null;
    else if (renderModal) return this.renderModal();
    else return this.renderInner();
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

const ActiveAccountsOfAgent = connect(
  mapStateToProps,
  mapDispatchToProps
)(ActiveAccountsOfAgentInner);

export default ActiveAccountsOfAgent;
